import { BreadCrumb } from "primereact/breadcrumb";

import { useHistory } from "react-router-dom";
import useCategories from "../../../../hooks/useCategories";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { locale } from "../../../../utilities/locale/locale";
import { useLocation } from "react-router-dom";
import localeText from "../../../../locale";

const BreadCrumbProduct = ({ selectedCategory, selectedSubcategory, product }) => {
  const history = useHistory();
  const { showErrorToast } = useToastContext();
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const labelCategory = {
    pt: selectedCategory?.descriptionPortuguese,
    en: selectedCategory?.descriptionEnglish,
    it: selectedCategory?.descriptionItalian,
    es: selectedCategory?.descriptionSpanish,
  };

  const labelSubcategory = {
    pt: selectedSubcategory?.descriptionPortuguese,
    en: selectedSubcategory?.descriptionEnglish,
    it: selectedSubcategory?.descriptionItalian,
    es: selectedSubcategory?.descriptionSpanish,
  };

  const home = {
    icon: "pi pi-home",
    command: () => {
      history.push("/shop");
    },
  };

  const itemTemplate = (item, props) => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a
        onClick={props.onClick}
        style={{ color: "#7A869A" }}
        className="cursor-pointer hover:underline text-sm font-medium"
      >
        <span style={{ whiteSpace: "nowrap" }}> {item.label}</span>
      </a>
    );
  };

  const productTemplate = (item, props) => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a style={{ color: "#7A869A" }} className="text-sm">
        <span
          style={{
            display: "block",
            maxWidth: "200px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {item.label}
        </span>
      </a>
    );
  };

  const items = [
    {
      label: labelCategory[locale],
      template: itemTemplate,
      command: () => {
        history.push(
          `/shop?search=ALL&currency=ALL&type=ALL&seller=ALL&area=ALL&category=${selectedCategory.id}&page=0&size=12`
        );
      },
    },
    {
      label: labelSubcategory[locale],
      template: itemTemplate,
      command: () => {
        history.push(
          `/shop?search=ALL&currency=ALL&type=ALL&seller=ALL&area=ALL&category=${selectedCategory.id}&subcategory=${selectedSubcategory.id}&page=0&size=12`
        );
      },
    },
    {
      label: product,
      template: productTemplate,
    },
  ].filter(({ label }) => Boolean(label));

  const fringeBenefitItems = [
    {
      label: labelCategory[locale],
    },
  ];

  return (
    <BreadCrumb
      className="border-none text-sm mb-2 px-0"
      style={{ backgroundColor: "inherit", color: "#7A869A" }}
      model={isFringeBenefitsPage ? fringeBenefitItems : items}
      home={home}
    ></BreadCrumb>
  );
};

export default BreadCrumbProduct;
